// extracted by mini-css-extract-plugin
export var optionGrid = "_a7-7";
export var optionList = "_a7-6";
export var questionsBlock = "_a7-9";
export var spacer = "_a7-5";
export var stepCenteredContent = "_a7-3";
export var stepInner = "_a7-0";
export var stepInnerFullWidth = "_a7-1";
export var stepInnerLockScroll = "_a7-2";
export var stepTransitionFrame = "_a7-4";
export var welcomeBlock = "_a7-8";